import Assessment from './Assessment';
import CompletedAssessments from './Completed';

export default Assessment;
export { CompletedAssessments };
